import React, { FC } from 'react';
import { Flex } from '@chakra-ui/react';

import { PlansVariant } from '__generated__/GQL';
import Heading from 'components/_core/Heading';
import IconButton from 'components/_core/IconButton';
import SunshineCard from 'components/_core/SunshineCard';

import BoxChoseVariant from '../BoxChoseVariant';
import locales from './locales';

interface AskVariantProps {
  onPrev: () => void;
  onChooseVariant: (variant: PlansVariant) => void;
}

const AskVariant: FC<AskVariantProps> = ({ onChooseVariant, onPrev }) => (
  <Flex
    alignItems="center"
    flexDir="column"
    paddingTop="space-16"
    paddingX="space-16"
  >
    <Flex
      alignItems="center"
      alignSelf="stretch"
      justifyContent="space-between"
      marginBottom="space-8"
    >
      <IconButton
        aria-label={locales.back}
        icon="arrow-left"
        onClick={onPrev}
        variant="inline-secondary"
      />
    </Flex>

    <Heading marginBottom="space-24" size="lg">
      {locales.askSituationTitle}
    </Heading>

    <SunshineCard.Group isBoxed={false} spacing="space-16">
      <BoxChoseVariant
        setVariant={onChooseVariant}
        variant={PlansVariant.Solo}
      />

      <BoxChoseVariant
        setVariant={onChooseVariant}
        variant={PlansVariant.Team}
      />
    </SunshineCard.Group>
  </Flex>
);

export default AskVariant;
